"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var mountIsland_1 = require("../mountIsland");
function GetHandbook() {
    var _a, _b, _c, _d;
    var handbookElement = document.getElementById('seminarLeaderHandbook');
    var textBefore = (_a = handbookElement === null || handbookElement === void 0 ? void 0 : handbookElement.getAttribute('data-text-before')) !== null && _a !== void 0 ? _a : 'Click';
    var textLink = (_b = handbookElement === null || handbookElement === void 0 ? void 0 : handbookElement.getAttribute('data-text-link')) !== null && _b !== void 0 ? _b : 'HERE';
    var textAfter = (_c = handbookElement === null || handbookElement === void 0 ? void 0 : handbookElement.getAttribute('data-text-after')) !== null && _c !== void 0 ? _c : 'to download your Seminar Leader Handbook.';
    var handbookLink = (_d = handbookElement === null || handbookElement === void 0 ? void 0 : handbookElement.getAttribute('data-handbook-link')) !== null && _d !== void 0 ? _d : '';
    return (react_1.default.createElement(material_1.Box, { className: "container student-container" },
        react_1.default.createElement(material_1.Typography, { variant: "inherit", component: "h5" },
            textBefore,
            ' ',
            react_1.default.createElement(material_1.Link, { href: handbookLink, target: "_blank", rel: "noopener noreferrer" }, textLink),
            ' ',
            textAfter)));
}
document.addEventListener('DOMContentLoaded', function () {
    var seminarLeaderHandbookContainer = document.getElementById('seminarLeaderHandbook');
    if (seminarLeaderHandbookContainer) {
        (0, mountIsland_1.mountIsland)(seminarLeaderHandbookContainer, react_1.default.createElement(GetHandbook, null));
    }
});
